import styled from 'styled-components'

import { Base } from './Base'

type Props = {
	imageUrl?: string | null
	square?: boolean
}

export const Logo = styled(Base)<Props>`
	background-size: cover;
	background-position: center center;
	background-image: url("${({ imageUrl }) => imageUrl}");
`
